import { render, staticRenderFns } from "./WabaSupsisAccountViolation.vue?vue&type=template&id=0f8dbdd4&scoped=true"
import script from "./WabaSupsisAccountViolation.vue?vue&type=script&lang=js"
export * from "./WabaSupsisAccountViolation.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisAccountViolation.vue?vue&type=style&index=0&id=0f8dbdd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8dbdd4",
  null
  
)

export default component.exports